module.exports = __webpack_public_path__ + "img/file_on_cloud.5375ba33.svg";